module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-23@2x-7da3685d42931e67ad684c011c03cf09.png";